// extracted by mini-css-extract-plugin
module.exports = {"activity_page":"guide_activity_page__QU1Fm","btn_box":"guide_btn_box__HUUdr","mask":"guide_mask__3EF9F"};